module.exports = __webpack_public_path__ + "img/type2-1.ce0848f2.png";